var render = function render(_c,_vm){return _c('Badge',{attrs:{"color":_vm.$options.methods.getColor(_vm.props.level),"rounded":true,"size":"large","indicator":true}},[_vm._v(_vm._s(_vm.props.level || 'Beginner'))])
}
var staticRenderFns = []

export { render, staticRenderFns }